import {inject, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {isPlatformBrowser} from '@angular/common';


export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  const platformId: any = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  if (isBrowser) {

    if (authService.currentUserValue) {
      return true;
    }
    const dontAddPathArray: string[] = ['account', 'accommodation', 'discover', 'housing-certificate'];
    const path = route.pathFromRoot[1].url[0].path;
    let loginRoute: string = '/login';
    if (!dontAddPathArray.includes(path)) {
      loginRoute = route.pathFromRoot[1].url[0].path + '/login';
    }
    router.navigate([loginRoute], {
      queryParams: {returnUrl: state.url},
    });
    return false;
  }

};
